import { BaseModel, type RelationConfig } from './base';
import { Employee } from './employee';
import { ResourceType } from './resourceType';

export class ServiceResource extends BaseModel {
  id!: number;
  idServiceResource!: number;
  name!: string;
  quantity!: number;
  customerVisible!: boolean;
  type!: ServiceResourceType;
  assignment!: ServiceResourceAssignment;
  defaultSelection!: ServiceResourceDefaultSelection;

  resource?: Employee; // Employee resource
  resourceType?: ResourceType;
  resources?: Employee[]; // Multiple employees

  static override relations(): RelationConfig {
    return {
      resource: { type: Employee },
      resourceType: { type: ResourceType },
      resources: { type: Employee },
    };
  }

  override objectID(): string {
    return this.idServiceResource?.toString() || '';
  }

  get isDefaultSelectionNone(): boolean {
    return this.defaultSelection === ServiceResourceDefaultSelection.none;
  }

  get isDefaultSelectionFirstAvailable(): boolean {
    return this.defaultSelection === ServiceResourceDefaultSelection.firstAvailable;
  }

  get isAssignmentReservation(): boolean {
    return this.assignment === ServiceResourceAssignment.reservation;
  }

  get isAssignmentCustomer(): boolean {
    return this.assignment === ServiceResourceAssignment.customer;
  }
}

export enum ServiceResourceAssignment {
  reservation = 0,
  customer = 1,
}

export const ServiceResourceAssignmentLabels: Record<ServiceResourceAssignment, string> = {
  [ServiceResourceAssignment.reservation]: 'general.reservation',
  [ServiceResourceAssignment.customer]: 'general.customer',
};

export enum ServiceResourceType {
  resource = 0,
  resourceType = 1,
}

export const ServiceResourceTypeLabels: Record<ServiceResourceType, string> = {
  [ServiceResourceType.resource]: 'general.resource',
  [ServiceResourceType.resourceType]: 'general.group',
};

export enum ServiceResourceDefaultSelection {
  none = -1,
  firstAvailable = 0,
}

export const ServiceResourceDefaultSelectionLabels: Record<ServiceResourceDefaultSelection, string> = {
  [ServiceResourceDefaultSelection.none]: 'resource.none',
  [ServiceResourceDefaultSelection.firstAvailable]: 'resource.firstAvailable',
};